import { Auditable } from "./auditable";
import { User } from "./user";

export enum ProjectStatus {
  NEW = "New",
  IN_PROGRESS = "In Progress",
  CANCELED = "Canceled",
  COMPLETED = "Completed"
}

export const ProjectStatuses: ProjectStatus[] = [
  ProjectStatus.NEW,
  ProjectStatus.IN_PROGRESS,
  ProjectStatus.CANCELED,
  ProjectStatus.COMPLETED
];

export enum ProjectType {
  // PROACTIVE_INSPECTION = "Proactive Inspection" TODO
  REACTIVE_INSPECTION = "Inspection",
  REPAIR = "Repair"
}

export const ProjectTypes: ProjectType[] = [
  ProjectType.REACTIVE_INSPECTION,
  ProjectType.REPAIR
];

export interface IProject extends Auditable {
  id: number;
  name: string;
  target_completion_date: string | null;
  closed_case_count: number;
  open_case_count: number;
  project_status: ProjectStatus;
  project_type: ProjectType;
  owner: number | null;
  owner_data: Partial<User> | null;
  default_action_assignee: number | null;
  default_action_assignee_data: Partial<User> | null;
  description: string;
  cases: number[];
  corresponding_action_assignees: Partial<User>[];
  open_action_count: number;
  in_progress_action_count: number;
  in_review_action_count: number;
  completed_action_count: number;
  canceled_action_count: number;
}

export interface ICreateProject {
  name: string;
  project_type: ProjectType;
  owner: number | null;
  default_action_assignee: number | null;
  target_completion_date?: string;
  description: string;
}

export interface IUpdateProject {
  name?: string;
  owner?: number | null;
  default_action_assignee: number | null;
  target_completion_date?: string | null;
  project_status?: ProjectStatus;
  project_type: ProjectType;
  description?: string;
}

export interface IProjectsResponse {
  count: number;
  results: IProject[];
  next?: string | null;
  previous?: string | null;
}

export interface IAddCasesToProject {
  project: number;
  cases: number[];
}
